<template>
  <div class="administrators-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-input
        placeholder="请输入管理员账号"
        clearable
        v-model="admParam.name"
        size="small"
        @keyup.enter.native="getAdmList('status')"
        class="param-input"
      ></el-input>
      <el-button type="primary" size="small" @click="getAdmList('status')"
        >搜索</el-button
      >
      <el-button type="primary" size="small" @click="adminOperation('add')"
        >+新增管理员</el-button
      >
    </div>
    <!--数据表格-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      ref="multipleTable"
      @sort-change="handleSortChange"
    >
      <el-table-column
        prop="id"
        label="管理员ID"
        align="center"
        min-width="240"
        fixed
      >
        <template slot-scope="scope">
          <span>{{ scope.row.id || '未知' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="nickname"
        label="管理员名"
        align="center"
        min-width="200"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.nickname || '未知' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="管理员账号"
        align="center"
        min-width="200"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.name || '未知' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="email" label="邮箱" align="center" min-width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.email || '未知' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="hasLocked"
        label="是否封禁"
        align="center"
        min-width="120"
        fixed="right"
      >
        <template slot-scope="scope">
          <span :style="!scope.row.hasLocked ? 'color:green' : 'color:red'">{{
            scope.row.hasLocked ? '已封禁' : '未封禁'
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="role" label="角色" align="center" min-width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.role || '未知' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createdAt"
        label="创建时间"
        align="center"
        min-width="200"
        sortable
      >
        <template slot-scope="scope">
          <span>{{ scope.row.createdAt | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="150">
        <template slot-scope="scope">
          <el-button
            type="success"
            class="el-icon-edit"
            size="mini"
            @click="adminOperation('edit', scope.row)"
          ></el-button>
          <el-button
            type="danger"
            class="el-icon-delete"
            size="mini"
            @click="removeAdmin(scope.row.id)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[10, 15, 20, 30]"
      :current-page="admParam.pageNumber"
      :page-size="admParam.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      v-if="total > 10"
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
    <!--新增、编辑弹框-->
    <add-admin ref="addAdmin" @handlerAdmList="getAdmList"></add-admin>
  </div>
</template>

<script>
import AddAdmin from "./components/addAdmin"
import API from '@/api'
import { sortEscape } from '@/utils/global'
export default {
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      tableData: [],
      total: 0,
      // 系统管理列表请求参数
      admParam: {
        pageNumber: 1,
        pageSize: 10,
        name: ''
      }
    }
  },
  components: {
    AddAdmin
  },
  created() {
    // this.$store.dispatch('setRouterTag', { router: '/administrators', routerName: "系统管理员" })
    this.getAdmList();
  },
  methods: {
    handleStatus(value) {
      if (!value) return false

    },
    // 请求管理员列表
    getAdmList(type) {
      this.loading = true;
      if (type === 'status') {
        this.admParam.pageNumber = 1
      }
      API.getAdmList(this.admParam).then(res => {
        if (res.code === 200 && res.data.list) {
          this.tableData = res.data.list
          this.total = res.data.total
        } else {
          this.tableData = []
          this.total = 0
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 数据排序
    handleSortChange(column) {
      this.admParam.value = sortEscape(column.order)
      this.admParam.key = column.prop;
      this.getAdmList()
    },
    // pageSize发生变化触发
    changeSize(size) {
      this.admParam.pageSize = size
      this.admParam.pageNumber = 1
      this.getAdmList()
    },
    // 当前页发生变化触发
    changeCurrent(pageNumber) {
      this.admParam.pageNumber = pageNumber
      this.getAdmList()
    },
    // 删除管理员
    removeAdmin(admID) {
      this.$confirm('您确定要删除当前选择管理员吗？', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          adminID: admID
        }
        API.delAdm(params).then(res => {
          if (res.code === 200) {
            this.$message({
              message: '删除管理员成功',
              type: 'success'
            })
            this.getAdmList('status')
          } else {
            this.$message.error('删除失败')
          }
        })
      })
    },
    // 新增、编辑操作
    adminOperation(type, data) {
      this.$refs.addAdmin.open(type, data)
    }
  }
}
</script>
